import { createRouter, createWebHistory } from 'vue-router';
import { routes } from 'vue-router/auto-routes';

import { useAuthStore } from '@/stores/auth.store';

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

const PUBLIC_ROUTES = ['/login'];

const ADMIN_ONLY_ROUTES = ['/settings/users'];

const WRITE_PROJECT_ROUTES = ['/projects/import'];

router.beforeEach((to) => {
  const authStore = useAuthStore();

  if (!authStore.isAuthenticated && !PUBLIC_ROUTES.includes(to.path)) {
    return { path: '/login', query: { redirect: to.fullPath } };
  }

  if (authStore.isAuthenticated && to.path === '/login') {
    return { path: '/' };
  }

  if (authStore.isAuthenticated) {
    if (ADMIN_ONLY_ROUTES.some((route) => to.path.startsWith(route)) && !authStore.isAdmin) {
      return { path: '/' };
    }

    if (WRITE_PROJECT_ROUTES.some((route) => to.path.startsWith(route)) && authStore.isSupervisor) {
      return { path: '/projects' };
    }
  }

  return true;
});
